"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveWebUserScope = exports.resolveUserScope = void 0;
exports.getMobileUserName = getMobileUserName;
exports.getWebUserName = getWebUserName;
exports.getMobileUserTeamLeader = getMobileUserTeamLeader;
const tools_1 = require("../../tools");
const types_1 = require("../../types");
const resolveScope_1 = require("../utils/resolveScope");
const utils_1 = require("../utils/utils");
const resolveUserScope = (metaExpression, options) => {
    var _a;
    // resolves mobile user 
    if (options.webUser)
        return (0, exports.resolveWebUserScope)(metaExpression, options);
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.USER)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    if (!options.user)
        return (0, utils_1.getMeResultNoResult)();
    let fieldWithoutUnderscore = metaExpression.field;
    if (((_a = metaExpression.field) === null || _a === void 0 ? void 0 : _a.startsWith("_")) && metaExpression.scope) {
        metaExpression.field = metaExpression.field.slice(1);
    }
    if (options.user && metaExpression.field === "name") {
        const name = getMobileUserName(options.user);
        if (name)
            return (0, utils_1.getMeResultFieldResult)(name);
    }
    if (options.user && metaExpression.field === "team_leader") {
        const allMobileUsers = options.allMobileUsers || [];
        const allTeams = options.allTeams || [];
        return getMobileUserTeamLeader(options.user, allMobileUsers, allTeams, metaExpression.option_tag);
    }
    return (0, resolveScope_1.resolveScope)(metaExpression, {
        object: options.user,
    });
};
exports.resolveUserScope = resolveUserScope;
const resolveWebUserScope = (metaExpression, options) => {
    var _a;
    // resolves mobile user 
    if (metaExpression.scope !== types_1.META_EXPRESSION_SCOPE.USER)
        throw new tools_1.InternalError("MetaExpression Scope not align.");
    if (!options.webUser)
        return (0, utils_1.getMeResultNoResult)();
    let fieldWithoutUnderscore = metaExpression.field;
    if (((_a = metaExpression.field) === null || _a === void 0 ? void 0 : _a.startsWith("_")) && metaExpression.scope) {
        metaExpression.field = metaExpression.field.slice(1);
    }
    if (options.webUser && metaExpression.field === "name") {
        const name = getWebUserName(options.webUser);
        if (name)
            return (0, utils_1.getMeResultFieldResult)(name);
    }
    return (0, resolveScope_1.resolveScope)(metaExpression, {
        object: options.webUser,
    });
};
exports.resolveWebUserScope = resolveWebUserScope;
function getMobileUserName(mobileUser) {
    if (mobileUser.first_name || mobileUser.last_name)
        return mobileUser.first_name + " " + mobileUser.last_name;
    else
        return undefined;
}
function getWebUserName(webUser) {
    if (webUser.first_name || webUser.last_name)
        return webUser.first_name + " " + webUser.last_name;
    else
        return undefined;
}
function getMobileUserTeamLeader(mobilerUser, allMobileUsers, teams, option_tag) {
    const mobileUserTeams = teams.filter((team) => team.mobile_users.includes(mobilerUser.id));
    if (!mobileUserTeams || mobileUserTeams.length === 0)
        return (0, utils_1.getMeResultNoResult)();
    if (mobileUserTeams.length > 1) {
        throw new tools_1.NotAllowedBusinessError("Cannot resolve team leader for mobile user in multiple teams");
    }
    const team = mobileUserTeams[0];
    const teamMembers = team.mobile_users.map((userId) => allMobileUsers.find((user) => user.id === userId));
    const teamLeaders = teamMembers
        .filter((value) => value === null || value === void 0 ? void 0 : value.is_team_leader)
        .filter((value) => value !== undefined);
    if (teamLeaders.length === 0)
        return (0, utils_1.getMeResultNoResult)();
    if (teamLeaders.length > 1) {
        throw new tools_1.NotAllowedBusinessError("Team has multiple leaders");
    }
    const teamLeader = teamLeaders[0];
    if (!teamLeader)
        return (0, utils_1.getMeResultNoResult)();
    return (0, utils_1.getMeResultFieldResult)(option_tag && teamLeader[option_tag]
        ? teamLeader[option_tag]
        : teamLeader.id);
}
